import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Location } from '@angular/common';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { FormNewComponent } from '../form-new/form-new.component';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { SelectForumModalComponent } from 'src/app/select-forum-modal/select-forum-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectProductToAttachComponent } from 'src/app/select-product-to-attach/select-product-to-attach.component';
import { MarketplacePageComponent } from '../../marketplace/marketplace.component';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-single-new',
  templateUrl: './single-new.component.html',
  styleUrls: ['./single-new.component.scss']
})
export class SingleNewComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('formNew') FormNewComponent: FormNewComponent;

  article: any = {
    related: [],
    bottomBannerLikes: []
  }
  imgUrl = environment.ImageUrl;
  isLogin: any = 0;
  appUserId: any = 0;

  carouselOptions: any = {
    // loop: true,
    nav: true,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    items: 3,
    // dots: true,
    responsive: {
      0: {
        items: 3
      },
    }
  };


  constructor(
    private toastr: ToastrService,
    public roleService: RoleService,
    private local: LocalServiceService,
    private sharedService: SharedService,
    private auth: AuthServiceService,
    private route: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    private location: Location,
    private seoService: SeoService,
    private router: Router,
    private modalService: NgbModal,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef
  ) {
  }

  private currentSlug = '';
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.currentSlug = params.get('slug')
      this.initData(this.currentSlug)
    });
    if (this.sharedService.isBrowser()) {
      this.local.getUserDetailsObserver().subscribe(user => {
        if (user?.id) {
          this.isUserAnAdmin = this.roleService?.roles?.userType.includes('ADMIN');
          this.appUserId = user.id;
          this.isLogin = 1;
        } else {
          this.isLogin = 0;
        }
      });
      this.checkReaderTime();
    }
  }

  /************************ code related to attaching products *********/

  public middleCaraouseConfig = {
    autoHeight: true,
    slidesPerView: 1,
    //spaceBetween: 10,
    nested: true,
    initialSlide: 1,
  }

  private _fetchForumReplies(forum) {
    this.auth.marketplace_forum_shop_fetch_reply(forum?.forumId, 1, true, false, 3)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          forum.replies = data.body
          this.cdr.detectChanges();
        }
      })
  }

  private _fetchNewsForums() {
    this.auth.getPagesLinkToForums('news', this.article?.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: data => {
            // for(const selected of data.body){
            //   this.linkedForum.add(selected.forumId)
            // }
            //console.log(data.body)
            if (Array.isArray(data.body)) {
              this.newsForums = structuredClone(data.body);
              for (const forum of this.newsForums) {
                this._fetchForumReplies(forum)
              }


            }


          },
          error: console.error
        }
      )

  }
  public attachedProducts = []
  private _getPageProductAttachments() {
    this.auth.getProuctListOfArticle(this.article?.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: data => {
          this.attachedProducts = data.body
        },
        error: console.error
      })
  }
  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;
  public openProduct(prod) {
    this.marketplacePage.viewProduct(prod, false, true)
    //window.open(window.location.origin + '/product/' + prod.slug, '_blank')
  }

  public openAttachProduct() {
    if (!this.isUserAnAdmin) {
      return;
    }
    const modalRef = this.modalService.open(SelectProductToAttachComponent, { size: 'sm', centered: true })
    modalRef.componentInstance.type = 'news'; //this need to be first from product id or whatever params so that the function can decide
    modalRef.componentInstance.newsId = this.article?.id;

    modalRef.hidden.subscribe(() => {
      this._getPageProductAttachments();
    })

  }

  /***********************  code related to forums ************************/
  public newsForums = []


  public isUserAnAdmin = false;

  public reloadForums() {
    this._fetchNewsForums();
  }

  @ViewChild('selectAdImageModal')
  public selectAdImageModal: TemplateRef<any>;


  public adImageUploadData = null;
  public adImageUpload64Data = null;
  public onAdImageSelect(event) {
    const file = event.target?.files[0];
    this.adImageUploadData = file;
    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.adImageUpload64Data = fileReader.result;
    }
    fileReader.readAsDataURL(file);
  }
  public openSelectAdImageModal() {
    this.modalService.open(this.selectAdImageModal, { size: 'sm', centered: true })
      .hidden.subscribe(() => {
        this.initData(this.currentSlug);
      })
  }
  public uploadAdImage() {
    if (!this.isUserAnAdmin) {
      return;
    }
    const file = this.adImageUploadData;
    this.modalService.dismissAll();
    const formData = new FormData();
    formData.append('bottomBannerId', this.article?.id)
    formData.append('adImage', file)
    this.auth.edit_bottom_banner(formData)

      .subscribe({
        next: () => {
          this.initData(this.currentSlug);
        },
        error: err => {
          console.error(err);
          this.toastr.error("Sometthign went wrong while setting ad")
        }
      })
  }
  // private _fetchNewsForums(){
  //   this.auth.getPagesLinkToForums('news', this.article?.id)
  //   .subscribe(
  //     {
  //       next: data =>{
  //         // for(const selected of data.body){
  //         //   this.linkedForum.add(selected.forumId)
  //         // }
  //         if(Array.isArray(data.body)){
  //            this.newsForums = data.body;
  //         }

  //       },
  //       error: console.error
  //     }
  //   )

  // }

  /********************************************************************* */
  public isLoading: boolean = true;
  initData(paramSlug?: string) {
    const slug = paramSlug ?? this.currentSlug
    this.location.replaceState('/news/' + slug)
    this.auth.get_bottom_banner_by_slug(slug)
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (response: any) => {
        this.article = response.body
        this._fetchNewsForums();

        this._getPageProductAttachments();
        this.article.descriptions = []
        this.article.tableOfContents = []

        let newText = this.article.text
        newText = newText.replaceAll('<table', '<div class="table-responsive"><table')
        newText = newText.replaceAll('</table>', '</table></div>')

        this.article.text = newText

        if (this.sharedService.isBrowser()) {
          await this.getTextBetweenHElements();
          this.getDescription()
          this.article.bottomBannerImages.map((row: any, index: number) => {
            this.article.text = this.article.text.replace(
              `$image${index}`,
              `<img src="${this.imgUrl + row.imageSrc}" />`
            )
          })


          let tables = document.querySelectorAll('table');
          tables.forEach(table => {
            table.classList.add('table');
          });
        }
        this.title.setTitle(`${response.body.title}`);

        this.seoService.update({
          title: `${response.body.title}`,
          description: this.article.tableOfContents.join('. '),
          main_title: ' | BEST SERVICES SG'
        })
        this.meta.addTags([
          { name: 'description', content: this.article.tableOfContents.join('. ') },
          { name: 'author', content: response.body.author },
          { name: 'keywords', content: `${response.body.category}, ${response.body.memberShopSubRegion}, ${response.body.memberShopCategory} ` }
        ]);
        this.seoService.addMetaTags(this.article?.metadata)

        this.seoService.initNewsSchema(this.article)
        if (this.article?.schema) this.seoService.updateSchema("custom", this.article?.schema)


        while (this.article.related.length < 3) {
          this.article.related.push({ id: ' ' }); // Add an empty placeholder item
        }
        this.isLoading = false;
        this.article.mockText = this.article.text
        this.cdr.detectChanges();
      }, (e) => {
        this.isLoading = false;
        // this.toastr.error("Article not found!");
        this.router.navigate(['/news'])
      });
  }

  cleanBlockquote(): string {
    return this.article.text.replace(/<blockquote[\s\S]*?<\/blockquote>/g, '');
  }
  goBack() {
    this.commonService.goBack();
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }

  formatEditedDate(unixTimestamp: number): string {
    const inputDate = moment.unix(unixTimestamp);
    const currentDate = moment();
    const daysDifference = currentDate.diff(inputDate, 'days');

    if (daysDifference === 0) {
      return `Edited today`;
    } else {
      return `Edited ${daysDifference} Days Ago`;
    }
  }

  removeHtmlTags(text: string): string {
    return text ? text.replace(/<[^>]*>/g, '') : '';
  }

  formatText(text: string, length): string {
    const cleanText = this.removeHtmlTags(text);
    return cleanText.length > length ? cleanText.substr(0, length) + '...' : cleanText;
  }

  tableOfContents: string[] = [];
  async getTextBetweenHElements() {
    if (!this.article?.text) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(this.article.text, 'text/html');
    const hElements = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');

    await Promise.all([hElements.forEach((hElement, index) => {
      const currentText = hElement.outerHTML ? hElement.outerHTML.replace(/<(\/?)h(\d)([^>]*)>/g, '<$1div class="h$2"$3>') : '';
      this.tableOfContents.push(currentText)

      const contentText = hElement.textContent ? hElement.textContent : '';
      this.article.tableOfContents.push(contentText)
    })]);
  }

  getDescription(): string {
    if (!this.article?.text) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(this.article.text, 'text/html');
    const hElements = doc.querySelectorAll('p, span');

    hElements.forEach((hElement, index) => {
      const currentText = hElement.textContent ? hElement.textContent : '';
      this.article.descriptions.push(currentText)
    });
  }

  public giveDiamondForReader(newsDiamondId, userId): void {
    if (newsDiamondId && userId && (userId != this.local.getUser().id)) {
      this.auth.addDiamondToReaderAccount({ id: newsDiamondId })

        .subscribe((resp: ApiResponse) => {
          this.toastr.success("Diamonds Added in Account successfully");
          this.auth.deleteNewsDiamond(newsDiamondId)

            .subscribe((resp: ApiResponse) => { });
        });
    }
  }

  timeout1: any;
  public checkReaderTime(): void {
    this.local.clearTimeout(this.timeout1)
    this.timeout1 = setTimeout(() => {
      this.giveDiamondForReader(this.article['memberNewsDiamond.id'], this.article['memberNewsDiamond.userId'])
    }, 2000)
  }


  hasChecked(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0
  }

  likeHandle(bottomBannerId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !")
    }
    const payload = {
      userId: this.appUserId,
      bottomBannerId: bottomBannerId
    }

    if (this.hasChecked(data.bottomBannerLikes))
      data.bottomBannerLikes = data.bottomBannerLikes.filter((row: any) => row.userId != this.appUserId)
    else
      data.bottomBannerLikes = [...data.bottomBannerLikes, payload]

    this.auth.likes_bottom_banner(payload)

      .subscribe(() => {
      })

  }

  editBlog(item: any) {
    this.FormNewComponent.openModalBlogForm(item)
  }


  deleteBlog(id: number) {
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.auth.delete_bottom_banner({ bottomBannerId: id })

          .subscribe(
            (response: any) => {
              // this.bottom_banner_image_url_show = 0;
              this.toastr.success(response.message);
              this.goBack()
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }

  goToHeader(item: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = item.trim();
    const parsedElement = tempDiv.firstElementChild;

    if (!parsedElement) {
      console.warn('Invalid HTML string provided');
      return;
    }

    const tagName = parsedElement.tagName.toLowerCase();
    const targetText = parsedElement.textContent?.trim();

    if (!tagName || !targetText) {
      console.warn('Missing tag name or text content');
      return;
    }

    // Limit search only within elements inside .content
    const allElements = Array.from(document.querySelectorAll('h1, h2, h3, h4, h5, h6'));
    for (const el of allElements) {
      const text = el.textContent?.trim();
      const isInsideContent = el.closest('.content');

      if (text === targetText && isInsideContent) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

  }

  openModalRelate(isRemove = false) {
    this.FormNewComponent.openModalRelate(this.article, isRemove, true)
  }

  ngOnDestroy(): void {
    console.log('[SingleNewComponent] Start Destroy');
    this.local.clearTimeout(this.timeout1)
    this.destroy$.next(null);
    this.destroy$.complete();
    console.log('[SingleNewComponent] End Destroy');
  }

  get articleText(): string {
    return this.article.mockText
      .replaceAll('<h1', '<div')
      .replaceAll('</h1>', '</div>')
      .replaceAll('<h2', '<div')
      .replaceAll('</h2>', '</div>')
      .replaceAll('<h3', '<div')
      .replaceAll('</h3>', '</div>')
      .replaceAll('<h4', '<div')
      .replaceAll('</h4>', '</div>')
      .replaceAll('<h5', '<div')
      .replaceAll('</h5>', '</div>')
      .replaceAll('<h6', '<div')
      .replaceAll('</h6>', '</div>');
  }
}
